import React, { createContext, useContext, useEffect, useState } from "react";
import { loginExternal } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("osint_user");
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch (e) { /* noop */ }
    }
    setReady(true);
  }, []);

  const login = async (email, password) => {
    const res = await loginExternal(email, password);
    if (res.ok) {
      const token = res.data.token || res.data.access_token || res.data.jwt;
      const u = res.data.user || { email, name: email };
      if (token) localStorage.setItem("osint_token", token);
      localStorage.setItem("osint_user", JSON.stringify(u));
      setUser(u);
      return { ok: true };
    }
    return { ok: false, error: res.error };
  };

  const logout = () => {
    localStorage.removeItem("osint_token");
    localStorage.removeItem("osint_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
